export default {
    header:{
        addWidget: {
            title: "Widget toevoegen",
            button: {
                title: "Voeg widget toe",
                hide: "Verberg reeds toegevoegd"
            }
        },
        datePicker:{
            title: "Datumbereik",
            options: {
                range: "Bereik",
                today: "Vandaag",
                yesterday: "Gisteren",
                last7Days: "Laatste 7 dagen",
                thisWeek: "Deze week",
                last30Days: "Laatste 30 dagen",
                thisMonth: "Deze maand",
                lastYear: "Laatste jaar",
                thisYear: "Dit jaar",
            },
            compareTo: {
                title: "Vergelijken met",
                previousPeriod: "Vorige periode",
                previousYear: "Vorig jaar"
            },
            cancel: "Annuleer",
            apply: "Toepassen",
            wrongStartDate: "Startdatum kan niet beginnen voor %{date}."
        },
        warning: {
            tooltip: "Klik voor meer informatie"
        },
        connection: {
            up: "connectie UP",
            down: "connectie DOWN"
        }
    },
    widget:{
        options:{
            move: "Verplaats",
            delete: "Verwijder"
        },
        moreInfo: "Meer informatie",
        noData: "Geen data beschikbaar voor deze widget.",
        noDataForPill: "Geen data beschikbaar voor %{pill}.",
        sync:{
            object: "Object",
            problem: "Probleem",
            nothing: "Geen synchronisatie problemen, goed bezig!"
        },
        search:{
            terms:{
                title: "Zoekterm",
                value: "# Opzoekingen"
            }
        },
        topProducts: {
            tableTitle: "Product"
        },
        topClients: {
            tableTitle: "Klant"
        },
        filters: {
            logins: "Logins",
            sales: "Omzet",
            orders: "Bestellingen",
            views: "Weergaven"
        },
        pageviews: {
            name: "Paginaweergaven",
            info: "Toont de meest bezochte pagina's met filters voor URL, Account en aantal weergaven"
        },
        pageVisits: {
            name: "Laatste bezoeken",
            info: "Toont de meest recente paginabezoeken met filters voor URL en Account"
        }
    },
    footer:{
        cancel: "Annuleer",
        save: "Sla veranderingen op"
    }
}